<template>
  <el-container>
    <el-container class="application-container" v-loading="loading">
      <el-header>
        <el-menu :default-active="$route.path" :router="true" background-color="#545C64" text-color="#fff" active-text-color="#ffd04b" mode="horizontal">
          <el-menu-item index="/dashboard">
            <i class="el-icon-menu"></i>
            <span>Dashboard</span>
          </el-menu-item>
          <el-menu-item index="/clientes">
            <i class="el-icon-menu"></i>
            <span>Clientes</span>
          </el-menu-item>
          <el-menu-item index="/imoveis">
            <i class="el-icon-document"></i>
            <span>Imóveis</span>
          </el-menu-item>
          <el-menu-item index="/vendas">
            <i class="el-icon-setting"></i>
            <span>Vendas</span>
          </el-menu-item>
        </el-menu>
      </el-header>
      
      <el-main class="application-main">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  }
}
</script>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    padding: 0px;
    z-index: 1000;
  }

  .application-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
    height: 100vh !important;
  }

  .application-main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 500;
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    height: 100vh !important;
    padding: 60px 0px 0px;
  }
</style>
